import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { changeLanguage } from '../../helpers/Language';
import { useQueryParams } from '../../helpers/useQuery';
import AuthenticationService from '../../services/AuthenticationService';

export const useProxy = () => {
  const {
    query,
    remove,
  } = useQueryParams();
  const { user } = useSelector((state) => state.authentication);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const sessionToken = sessionStorage.getItem('proxy_token');
    const lng = query.get('language');

    if (lng) {
      changeLanguage(lng);
    }

    if (sessionToken) {
      remove('proxy_token');
    } else if (query.get('proxy_token')) {
      sessionStorage.setItem('proxy_token', query.get('proxy_token'));
      sessionStorage.setItem('proxy_project', query.get('proxy_project') || 'myOwnData');
      if (query.has('proxy_project')) {
        localStorage.setItem('source', 'overview');
      }
      remove('proxy_token');
      window.location.reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (query.has('language')) {
      if (user && user.langauge !== query.get('language')) {
        const changeLang = async () => {
          await AuthenticationService.updateLanguage(query.get('language'));
          setLoaded(true);
        };

        changeLang();
      } else {
        setLoaded(true);
      }
    } else {
      setLoaded(true);
    }
  }, [user]);

  return {
    user: loaded ? user : undefined,
  }
}
